import type { PayloadAction } from "@reduxjs/toolkit";

import type { IFavorites } from "./models";

export const UPDATE = "favorites/update";
export function updateFavorites(
  payload: IFavorites,
): PayloadAction<IFavorites> {
  return {
    type: UPDATE,
    payload,
  };
}
